import type { CustomThemeConfig } from '@pba/react-theme';
import { useCallback } from 'react';
import { useResolveSpacingValue } from './useResolveSpacingValue';

export type PairSpacingValue = readonly [SpacingInput, SpacingInput] | SpacingInput;

export type SpacingInput = 0 | SpacingKey;

export type SpacingKey = keyof CustomThemeConfig['spacing'];

const isPairSpacing = (value: PairSpacingValue): value is readonly [SpacingInput, SpacingInput] => Array.isArray(value);

export const useResolvePairSpacing = () => {
  const resolveSpacingValue = useResolveSpacingValue();

  return useCallback(
    (value?: PairSpacingValue): [start: number | undefined, end: number | undefined] => {
      if (value === undefined) {
        return [undefined, undefined];
      }

      if (isPairSpacing(value)) {
        const [start, end] = value;

        return [resolveSpacingValue({ value: start }), resolveSpacingValue({ value: end })];
      }

      const spacing = resolveSpacingValue({ value });

      return [spacing, spacing];
    },
    [resolveSpacingValue],
  );
};
